<ng-container *ngIf="modulePermitted; else moduleNotPermitted">
    <div class="row match-panel-heights">
        <div class="col-lg-6 col-md-6 col-xs-12">
            <!-- DETAILS FORM -->
            <form #detailsForm="ngForm" novalidate>
                <div class="panel panel-white">
                    <div class="panel-heading border-light">
                        <h4 class="panel-title">Job Details</h4>
                        <ul class="panel-heading-tabs border-light">
                            <li *ngIf="permissions.canEditJobDetails">
                                <div class="btn-group">
                                    <button
                                        id="startDetailsEdit"
                                        type="button"
                                        class="btn btn-info"
                                        *ngIf="!editModes.job"
                                        (click)="startEditing(detailsForm, 'job')"
                                        tooltip="Edit job details"
                                        container="body"
                                        [disabled]="editModes.customer || editModes.location">
                                        <i class="ti-pencil"></i>
                                    </button>
                                    <button
                                        id="submitDetailsForm"
                                        type="button"
                                        class="btn btn-warning"
                                        *ngIf="editModes.job"
                                        (click)="saveDetails()"
                                        [disabled]="!detailsForm.valid">
                                        <i class="ti-check"></i>
                                        Save
                                    </button>
                                    <button
                                        id="cancelDetailsForm"
                                        type="button"
                                        class="btn btn-default"
                                        *ngIf="editModes.job"
                                        (click)="cancelForm('job')">
                                        <i class="ti-close"></i>
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="panel-body">
                        <div class="form-group">
                            <label class="text-info fixed-label"> Number </label>
                            <span *ngIf="!editModes.job"
                                ><strong>{{ job.Number }}</strong></span
                            >
                            <input
                                legacy-css
                                type="text"
                                name="number"
                                class="form-control"
                                *ngIf="editModes.job"
                                [(ngModel)]="job.Number"
                                validator="minlength=1,maxlength=30"
                                maxlength="30"
                                appNullReplace
                                required />
                            <span class="validation-invalid" *ngIf="numberInvalid">This number is already in use.</span>
                        </div>
                        <div class="form-group">
                            <label class="text-info fixed-label"> Description </label>
                            <span *ngIf="!editModes.job"
                                ><strong>{{ job.Description }}</strong></span
                            >
                            <input
                                legacy-css
                                name="description"
                                type="text"
                                class="form-control"
                                *ngIf="editModes.job"
                                [(ngModel)]="job.Description"
                                validator="minlength=1,maxlength=50"
                                maxlength="50"
                                required />
                        </div>
                        <div class="form-group">
                            <label class="text-info fixed-label"> Created </label>
                            <span *ngIf="!editModes.job">{{ job.CreationDate | date }}</span>
                            <div class="form-group">
                                <div class="input-group" *ngIf="editModes.job">
                                    <input
                                        legacy-css
                                        bsDatepicker
                                        [bsConfig]="{
                                            adaptivePosition: true,
                                            showWeekNumbers: false,
                                            containerClass: 'theme-default',
                                            customTodayClass: 'bsdatepicker-today',
                                            dateInputFormat: dateFormat,
                                        }"
                                        #createdDate="bsDatepicker"
                                        autocomplete="off"
                                        required
                                        type="text"
                                        class="form-control form-control-v2"
                                        [(ngModel)]="job.CreationDate"
                                        id="createdDate"
                                        name="createdDate" />

                                    <span class="input-group-btn">
                                        <button id="openDatepicker" type="button" class="btn btn-default" (click)="createdDate.show()">
                                            <i class="glyphicon glyphicon-calendar"></i>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="text-info fixed-label"> Building Type </label>
                            <span *ngIf="!editModes.job">{{ job.BuildingType }}</span>
                            <div class="form-group" *ngIf="editModes.job">
                                <app-building-type-selector
                                    triggerId="jobDetailsBuildingTypesTrigger"
                                    name="buildingType"
                                    [legacyCss]="true"
                                    [(ngModel)]="job.BuildingType"
                                    placeholder="Building type...">
                                </app-building-type-selector>
                            </div>
                        </div>
                        <div class="form-group" *ngIf="job.CalculationMethod == 0">
                            <span *ngIf="!editModes.job">{{ job.TaxRatePercent }}%</span>
                            <div class="form-group" *ngIf="editModes.job">
                                <div class="input-group">
                                    <input
                                        legacy-css
                                        type="text"
                                        name="taxRatePercent"
                                        step="any"
                                        class="form-control"
                                        [(ngModel)]="job.TaxRatePercent"
                                        min="0"
                                        appNullReplace="0"
                                        required />
                                    <span class="input-group-addon">%</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" *ngIf="job.CalculationMethod >= 1">
                            <label class="text-info fixed-label"> Tax Profile </label>
                            <span *ngIf="!editModes.job">{{ displayTaxProfile }}</span>
                            <div class="form-group" style="display: flex" *ngIf="editModes.job">
                                <input
                                    legacy-css
                                    type="text"
                                    class="form-control"
                                    style="width: 100%"
                                    [(ngModel)]="displayTaxProfile"
                                    name="displayTaxProfile"
                                    disabled />
                                <button
                                    type="button"
                                    class="btn btn-primary"
                                    style="margin-left: 10px; width: auto"
                                    (click)="editTaxRates()">
                                    Customize
                                </button>
                            </div>
                        </div>
                        <div class="form-group" *ngIf="sharedData.UserData.tenant.ID_Franchise">
                            <label class="text-info fixed-label">Franchise Fee</label>
                            <span *ngIf="!editModes.job || sharedData.UserData.user.Role !== 'FranchiseUser'"
                                >{{ job.FranchiseFeePercent }}%</span
                            >
                            <div *ngIf="editModes.job && sharedData.UserData.user.Role === 'FranchiseUser'" class="input-group">
                                <input
                                    legacy-css
                                    type="number"
                                    step="any"
                                    class="form-control"
                                    name="franchiseFeePercent"
                                    [(ngModel)]="job.FranchiseFeePercent" />
                                <span class="input-group-addon">%</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="text-info fixed-label"> Invoice Method </label>
                            <span *ngIf="!editModes.job || (editModes.job && hasInvoices())">{{ getInvoiceMethodName() }}</span>
                            <span *ngIf="!editModes.job && job.IsInvoiceMethodCostPlus"> ({{ job.CostPlusPercentage }}%)</span>
                            <span *ngIf="job.IsInvoiceMethodContractPrice && !editModes.job">
                                ({{ job.ContractTotalIncTax | bxCurrency }})</span
                            >
                            <a
                                *ngIf="job.IsInvoiceMethodContractPrice && !job.HasEstimate && editModes.job"
                                (click)="changeContractPrice()">
                                ({{ job.ContractTotalIncTax | bxCurrency }})</a
                            >
                            <span *ngIf="job.IsInvoiceMethodContractPrice && job.HasEstimate && editModes.job">
                                ({{ job.ContractTotalIncTax | bxCurrency }})</span
                            >
                            <span *ngIf="includeRetention && !editModes.job">
                                (<strong>{{ job.RetentionPaymentPercentage }}%</strong> of each invoice will be retained, until
                                <strong>{{ job.RetentionPercentage }}%</strong> of the contract total ({{
                                    job.RetentionType === 0 ? 'excl' : 'incl'
                                }}
                                {{ 'general.variations' | translate | lowercase }}) is reached.)
                            </span>
                            <select
                                legacy-css
                                class="form-control"
                                id="frmInvoiceMethod"
                                name="invoiceMethod"
                                *ngIf="editModes.job && !hasInvoices()"
                                [(ngModel)]="job.InvoiceMethod"
                                (change)="changeInvoiceMethod()"
                                required>
                                <option value="" disabled>Choose Method</option>
                                <option
                                    *ngFor="let m of invoiceMethods"
                                    [value]="m.value"
                                    [disabled]="isInvoiceMethodAvailable(m.value) ? null : true">
                                    {{ m.name }}
                                </option>
                            </select>
                            <div class="alert alert-danger margin-top-5" *ngIf="hasInvoices() && editModes.job">
                                <span><i class="icon-ic-alert-s1"></i> Invoice method cannot be changed when the job has invoices.</span>
                            </div>
                        </div>
                        <div class="form-group" *ngIf="editModes.job && job.IsInvoiceMethodCostPlus">
                            <label class="text-info fixed-label"> Cost Plus</label>
                            <div class="form-group" *ngIf="editModes.job">
                                <div class="input-group">
                                    <input
                                        legacy-css
                                        type="number"
                                        step="any"
                                        class="form-control"
                                        name="costPlusPercentage"
                                        [(ngModel)]="job.CostPlusPercentage"
                                        min="0"
                                        appNullReplace="0"
                                        [disabled]="hasInvoices()"
                                        required />
                                    <span class="input-group-addon">%</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" *ngIf="includeRetention && editModes.job">
                            <div class="row">
                                <div class="col-xs-12">
                                    <div class="checkbox clip-check check-primary">
                                        <input
                                            legacy-css
                                            type="checkbox"
                                            id="includeRetention"
                                            name="includeRetention"
                                            [(ngModel)]="includeRetention"
                                            [disabled]="!editModes.job || hasInvoices()" />
                                        <label for="includeRetention"> Calculate retention for this contract? </label>
                                    </div>
                                </div>
                            </div>
                            <div
                                id="job-edit-cost-plus-retention"
                                class="row job-edit-cost-plus-retention"
                                *ngIf="includeRetention && !isCompletionPercentForOldEstimate()">
                                <div class="col-xs-4">
                                    <div class="form-group">
                                        <label class="text-info"> Retention per Invoice </label>
                                        <div class="input-group">
                                            <input
                                                legacy-css
                                                type="number"
                                                min="1"
                                                max="100"
                                                class="form-control"
                                                step="any"
                                                name="retentionPaymentPercentage"
                                                [(ngModel)]="job.RetentionPaymentPercentage"
                                                [disabled]="!editModes.job || hasInvoices()"
                                                required
                                                tooltip="Percentage per invoice that will be retained" />
                                            <span class="input-group-addon">%</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-4">
                                    <div class="form-group">
                                        <label class="text-info"> Retention total </label>
                                        <div class="input-group">
                                            <input
                                                legacy-css
                                                type="number"
                                                min="1"
                                                max="100"
                                                class="form-control"
                                                step="any"
                                                name="retentionPercentage"
                                                [(ngModel)]="job.RetentionPercentage"
                                                [disabled]="!editModes.job || hasInvoices()"
                                                required
                                                tooltip="Percentage of the contract to be retained" />
                                            <span class="input-group-addon">%</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-4">
                                    <div class="form-group">
                                        <label class="text-info"> How to calculate total </label>
                                        <select
                                            legacy-css
                                            class="form-control"
                                            name="retentionType"
                                            [(ngModel)]="job.RetentionType"
                                            [disabled]="!editModes.job || hasInvoices()"
                                            required>
                                            <option value="" disabled>Choose How</option>
                                            <option *ngFor="let r of retentionTypes" [value]="r.value">{{ r.name }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="includeRetention">
                                <div class="col-xs-12">
                                    <div class="alert alert-info">
                                        <p>
                                            <strong>{{ job.RetentionPaymentPercentage }}%</strong> of each invoice will be retained, until
                                            <strong>{{ job.RetentionPercentage }}%</strong> of the contract total ({{
                                                job.RetentionType === 0 ? 'excl' : 'incl'
                                            }}
                                            {{ 'general.variations' | translate | lowercase }}) is reached.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" *ngIf="job.HasEstimate">
                            <label class="text-info fixed-label"> Estimate </label>
                            <span>{{ job.Estimate?.FullDescription }}</span>
                        </div>
                    </div>
                </div>
            </form>

            <form #customerForm="ngForm" novalidate>
                <div class="panel panel-white">
                    <div class="panel-heading border-light">
                        <h4 class="panel-title">Client Details</h4>
                        <ul class="panel-heading-tabs border-light" *ngIf="permissions.canEditJobDetails">
                            <li>
                                <div class="btn-group">
                                    <button
                                        type="button"
                                        class="btn btn-info"
                                        tooltip="Edit client details"
                                        container="body"
                                        *ngIf="!editModes.customer"
                                        (click)="startEditing(customerForm, 'customer')"
                                        [disabled]="editModes.job || editModes.location">
                                        <i class="ti-pencil"></i>
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-warning"
                                        *ngIf="editModes.customer"
                                        (click)="saveCustomer(customerForm)"
                                        [disabled]="!customerForm.valid">
                                        <i class="ti-check"></i>
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-default"
                                        *ngIf="editModes.customer"
                                        (click)="cancelForm('customer')">
                                        <i class="ti-close"></i>
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="panel-body">
                        <div class="form-group">
                            <label class="text-info fixed-label"> Name </label>
                            <span *ngIf="!editModes.customer"
                                ><strong>{{ job.ClientName }}</strong></span
                            >
                            <div class="form-group" *ngIf="editModes.customer">
                                <app-bx-customer-selector
                                    id="jobCustomer"
                                    name="jobCustomer"
                                    [(ngModel)]="job.ClientName"
                                    (customerSelect)="updateCustomerAddress($event)"
                                    [required]="true"></app-bx-customer-selector>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="text-info fixed-label"> Address </label>
                            <a
                                *ngIf="!editModes.customer"
                                href="https://www.google.com/maps/place/{{ getEncodedAddress(job.AddressFormatted!) }}"
                                target="_blank"
                                >{{ job.AddressFormatted }}</a
                            >
                            <app-bx-address-input
                                [inputLegacyCss]="true"
                                *ngIf="editModes.customer"
                                inputClass="form-control form-control-v2"
                                id="address1"
                                name="address1"
                                #address1="ngModel"
                                inputMaxLength="200"
                                [(ngModel)]="job.ClientAddress1"
                                (onAddressSelected)="handleAddressChange($event)" />
                        </div>
                        <div *ngIf="editModes.customer">
                            <div class="form-group">
                                <label class="text-info" translate="general.address.city"></label>
                                <input
                                    legacy-css
                                    type="text"
                                    name="clientCity"
                                    [attr.placeholder]="'general.address.city' | translate"
                                    class="form-control"
                                    [(ngModel)]="job.ClientCityTown"
                                    maxlength="50" />
                            </div>
                            <div class="row">
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label translate="general.address.state"></label>
                                        <select legacy-css class="form-control" name="clientState" [(ngModel)]="job.ClientState">
                                            <option value="">Please select</option>
                                            <option
                                                [value]="s.value"
                                                [attr.selected]="job.ClientState === s.value ? true : null"
                                                *ngFor="let s of sharedData.Common.StatesInfo">
                                                {{ s.value }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label translate="general.address.postcode"></label>
                                        <input
                                            legacy-css
                                            type="text"
                                            name="clientPostCode"
                                            [attr.placeholder]="'general.address.postcode' | translate"
                                            class="form-control"
                                            [(ngModel)]="job.ClientPostCode"
                                            maxlength="10" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="text-info fixed-label"> Phone </label>
                            <span *ngIf="!editModes.customer">{{ job.ClientPhone | phoneNumberLocalize }}</span>
                            <div class="form-group" *ngIf="editModes.customer">
                                <phone-number
                                    name="phoneCustom"
                                    ngDefaultControl
                                    [number]="job.ClientPhone"
                                    [(ngModel)]="job.ClientPhone"
                                    (valid)="validatePhoneError('phoneCustom', customerForm, $event)"
                                    (parsednumber)="job.ClientPhone = $event"></phone-number>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="text-info fixed-label" translate="general.address.mobile"></label>
                            <span *ngIf="!editModes.customer">{{ job.ClientMobile | phoneNumberLocalize }}</span>
                            <div class="form-group" *ngIf="editModes.customer">
                                <phone-number
                                    name="mobileCustom"
                                    ngDefaultControl
                                    [number]="job.ClientMobile"
                                    [(ngModel)]="job.ClientMobile"
                                    (valid)="validatePhoneError('mobileCustom', customerForm, $event)"
                                    (parsednumber)="job.ClientMobile = $event"></phone-number>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="text-info fixed-label"> Email </label>
                            <span *ngIf="!editModes.customer">{{ job.ClientEmail }}</span>
                            <div class="form-group" *ngIf="editModes.customer">
                                <input
                                    legacy-css
                                    type="email"
                                    placeholder="Email"
                                    name="clientEmail"
                                    class="form-control"
                                    [(ngModel)]="job.ClientEmail"
                                    maxlength="50" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="col-lg-6 col-md-6 col-xs-12">
            <!-- LOCATION FORM -->
            <form #locationForm="ngForm" novalidate>
                <div class="panel panel-white">
                    <div class="panel-heading border-light">
                        <h4 class="panel-title">Work Location</h4>
                        <ul class="panel-heading-tabs border-light">
                            <li *ngIf="permissions.canEditJobDetails">
                                <div class="btn-group">
                                    <button
                                        id="editLocationForm"
                                        type="button"
                                        class="btn btn-info"
                                        *ngIf="!editModes.location"
                                        (click)="startEditing(locationForm, 'location')"
                                        title="Edit work location"
                                        container="body"
                                        [disabled]="editModes.job || editModes.customer">
                                        <i class="ti-pencil"></i>
                                    </button>
                                    <button
                                        id="submitLocationForm"
                                        type="button"
                                        class="btn btn-warning"
                                        *ngIf="editModes.location"
                                        (click)="saveWorksLocation(locationForm)">
                                        <i class="ti-check"></i>
                                        Save
                                    </button>
                                    <button
                                        id="cancelLocationForm"
                                        type="button"
                                        class="btn btn-default"
                                        *ngIf="editModes.location"
                                        (click)="cancelForm('location')">
                                        <i class="ti-close"></i>
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="panel-body">
                        <div class="form-group">
                            <label class="text-info fixed-label"> Address </label>
                            <a
                                class="location-address"
                                *ngIf="!editModes.location"
                                href="https://www.google.com/maps/place/{{ getEncodedAddress(job.WorksLocationFormatted) }}"
                                target="_blank"
                                ><strong>{{ job.WorksLocationFormatted }}</strong></a
                            >

                            <app-bx-address-input
                                [inputLegacyCss]="true"
                                *ngIf="editModes.location"
                                inputClass="form-control form-control-v2"
                                id="address2"
                                name="address2"
                                #address2="ngModel"
                                [(ngModel)]="job.WorksLocationAddress"
                                (onAddressSelected)="handleWorksLocationAddressChange($event)"
                                inputMaxLength="100" />
                        </div>
                        <div *ngIf="editModes.location">
                            <div class="row">
                                <div class="col-xs-6">
                                    <div class="form-group">
                                        <label translate="general.address.city"></label>
                                        <input
                                            legacy-css
                                            type="text"
                                            [attr.placeholder]="'general.address.city' | translate"
                                            class="form-control"
                                            id="WorksLocationSuburb"
                                            name="WorksLocationSuburb"
                                            [(ngModel)]="job.WorksLocationSuburb"
                                            maxlength="50" />
                                    </div>
                                </div>
                                <div class="col-xs-3">
                                    <div class="form-group">
                                        <label translate="general.address.state"></label>
                                        <select
                                            legacy-css
                                            class="form-control"
                                            id="WorksLocationState"
                                            name="WorksLocationState"
                                            [(ngModel)]="job.WorksLocationState">
                                            <option value="null">Please select</option>
                                            <option [value]="s.value" *ngFor="let s of sharedData.Common.StatesInfo">{{ s.value }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-xs-3">
                                    <div class="form-group">
                                        <label translate="general.address.postcode"></label>
                                        <input
                                            legacy-css
                                            type="text"
                                            [attr.placeholder]="'general.address.postcode' | translate"
                                            class="form-control"
                                            id="WorksLocationPostcode"
                                            name="WorksLocationPostcode"
                                            [(ngModel)]="job.WorksLocationPostcode"
                                            maxlength="50" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="job-details-map-container">
                            <iframe [attr.src]="worksLocationUrl" frameborder="0" allowfullscreen
                                ><p>Your browser does not support iFrames.</p></iframe
                            >
                        </div>
                    </div>
                </div>
            </form>
            <!-- Integrations Panel -->
            <section class="card" *ngIf="showDeputyIntegrationsPanel">
                <!-- Integrations Panel -->
                <header>
                    <h3>Integrations</h3>
                </header>
                <div class="card-content">
                    <form class="form-v2">
                        <div class="form-group">
                            <div style="display: flex; align-items: center; padding-bottom: 5px">
                                <label class="text-info fixed-label" style="width: calc(100% - 180px) !important; display: inline-block">
                                    Deputy Location {{ linkedDeputyAreaText }}
                                </label>
                            </div>
                            <div style="display: flex; align-items: center; padding-top: 5px">
                                <ng-select
                                    [(ngModel)]="job.TimesheetLocationId"
                                    [ngModelOptions]="{ standalone: true }"
                                    style="width: calc(100% - 180px) !important; display: inline-block"
                                    class="light"
                                    [items]="deputyLocationList"
                                    bindValue="deputyId"
                                    bindLabel="deputyLocation"
                                    (change)="setDeputyLocationID($event.deputyId)"
                                    [disabled]="!!job.TimesheetLocationId || !deputyLocationList"
                                    placeholder="Select a Deputy location...">
                                    <ng-template ng-label-tmp let-item="item">
                                        {{ item.deputyLocation }}
                                    </ng-template>
                                    <ng-template ng-option-tmp let-item="item">
                                        {{ item.deputyLocation }}
                                    </ng-template>
                                </ng-select>
                                <button
                                    type="button"
                                    class="btn-bx-primary ml-2"
                                    (click)="createDeputyLocation()"
                                    [disabled]="!job.WorksLocationAddress"
                                    *ngIf="!job.TimesheetLocationId">
                                    <i class="ti-plus"></i>
                                    Create Location
                                </button>
                                <button
                                    *ngIf="job.TimesheetLocationId"
                                    class="btn-bx-secondary-stroked ml-2 min-width-30"
                                    [matMenuTriggerFor]="deputyMoreActions"
                                    title="More Actions">
                                    <i class="fa fa-ellipsis-v"></i>
                                </button>
                                <mat-menu #deputyMoreActions>
                                    <button mat-menu-item (click)="clearDeputyLocationID($event)">Unlink location</button>
                                    <button
                                        mat-menu-item
                                        (click)="setupDeputyAreas()"
                                        *ngIf="job.TimesheetLocationId && job.JobItems?.length">
                                        Manage areas
                                    </button>
                                </mat-menu>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>

    <div class="row match-panel-heights">
        <div class="col-sm-6">
            <div *ngIf="permissions.viewDocuments">
                <app-bx-documents
                    [reference]="job.ID_Job"
                    [references]="documentsParams?.references"
                    [leadId]="job.ID_Lead"
                    [sourceType]="jobSource"
                    [enableMultiselect]="true"
                    [enableStickyActionBar]="true"
                    [enableMoveFile]="true"
                    [hideAddButton]="!permissions.addDocuments"
                    [hideTrashIcon]="!permissions.deleteDocuments"
                    [labelDisclaimer]="'documents.uploadDisclaimer' | translate">
                </app-bx-documents>
            </div>

            <app-job-crew-invitations [jobId]="job.ID_Job" />
        </div>
        <div class="col-sm-6">
            <!--Notes Panel-->
            <app-notes
                [title]="'Notes'"
                [source]="'Jobs'"
                [view]="permissions.viewNotes"
                [add]="permissions.addNotes"
                [delete]="permissions.deleteNotes"
                [referenceId]="job.ID_Job"
                [queryReferenceIds]="[job.ID_Job, job.ID_Estimate, job.ID_Customer, job.ID_Lead]"></app-notes>

            @if (digitalSignaturesEnabled) {
                <app-digital-signature-list
                    [referenceId]="job.ID_Job"
                    [shareReferenceType]="'JOB'"
                    (onViewReference)="openJobVariation($event.id)" />
            }
        </div>
    </div>
</ng-container>

<ng-template #moduleNotPermitted>
    <app-bx-permission-notification></app-bx-permission-notification>
</ng-template>
